module.exports = __webpack_public_path__ + "img/chart-line-single.efb5012a.svg";